import { cn } from '@/lib/utils';

export function NeedNumberCell({
  value,
  strong = false,
}: {
  value: number;
  strong?: boolean;
}) {
  return (
    <span
      className={cn(
        'pr-1 text-xs tabular-nums',
        strong ? 'font-medium text-gray-900' : 'text-gray-500',
      )}
    >
      {value.toLocaleString()}
    </span>
  );
}
